export enum ManagementMandateStatus {
  NO_MANDATE = 'noMandate',
  EXPIRED_MANDATE = 'expiredMandate',
  SENDED_MANDATE = 'sendedMandate',
  SIGNED_MANDATE = 'signedMandate',
  ASSOCIATED_MANDATE = 'associatedMandate',
  INTEGRITY_ERROR = 'integrityError',
}
